<template>
  <v-container :id="files.name">
    <view-intro :heading="files.name" />
    <div class="d-flex">
      <v-btn color="primary" text @click="goBack">
        Back
      </v-btn>
      <v-btn color="primary" class="ml-auto" @click="uploadDialog = true">
        Upload Files
      </v-btn>
    </div>

    <material-card
      icon="mdi-clipboard-text"
      icon-small
      :title="`${files.name ? files.name : ''} files`"
      color="accent"
      class="pa-4 mb-4"
    >
      <!-- <div class="py-3" />
      <div class="px-4 mb-4">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </div> -->
    </material-card>
    <div v-if="!loading && files.files">
      <v-row v-if="files.files.length > 0">
        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          v-for="(file, index) in files.files"
          :key="index"
        >
          <v-card class="mx-auto">
            <v-img
              class="primary darken-1 white--text align-center"
              height="200px"
            >
              <div class="d-flex align-center justify-center">
                <v-icon size="120" color="white">mdi-file-document</v-icon>
              </div>
              <v-card-title class="white--text"
                ><strong>{{ file.media[0].name }}</strong></v-card-title
              >
            </v-img>

            <v-card-subtitle class="pb-0">
              <strong>{{ file.name }}</strong>
            </v-card-subtitle>
            <v-card-actions>
              <v-btn
                color="primary"
                icon
                :download="file.name"
                :href="getLink(file.media[0].url)"
                target="_blank"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
              <v-btn
                color="purple"
                icon
                @click="initializeShare(file.name, file.id)"
              >
                <v-icon>mdi-share-variant</v-icon>
              </v-btn>
              <v-btn
                color="red"
                icon
                @click="initiateDelete(file.id, file.media[0].id, file.name)"
              >
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
      <v-card v-else height="500">
        <img
          src="../assets/Laptop-01.svg"
          alt="Empty"
          class="empty-img"
          style="height: 80%; width: auto; margin: auto; display: block;"
        />
        <v-card-title
          class="text--secondary text-h5 mx-auto mt-n16 empty-text"
          style="text-align: center; display: block;"
          ><strong
            >You have not have any files in this folder</strong
          ></v-card-title
        >
      </v-card>
    </div>
    <div class="mt-16" v-else>
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
      <v-card-title class="text--secondary text-h6 mx-auto mt-n16 empty-text"
        ><strong>Getting your files</strong></v-card-title
      >
    </div>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-form ref="fileShareForm" @submit.prevent="shareFile">
          <v-card-title>
            <span class="text-h4 my-2"
              ><strong>Share {{ fileToShare.name }} With</strong></span
            >
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-autocomplete
                filled
                label="Select Users"
                :items="usersToShare"
                item-text="username"
                item-value="id"
                v-model="selected"
                :rules="[v => !!v || 'You must select a user to proceed']"
                small-chips
                clearable
                hide-details
                no-data-text="No available users"
              ></v-autocomplete>
            </v-container>
          </v-card-text>
          <v-card-actions class="pr-6 pb-5">
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialog = false">
              Cancel
            </v-btn>
            <v-btn color="primary" type="submit" :loading="sharingFile">
              Share
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="uploadDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h4 my-2"><strong>Upload file</strong></span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-text-field
              filled
              label="File Name"
              v-model="fileName"
            ></v-text-field>
            <v-file-input
              chips
              filled
              label="Choose File"
              @change="initialiseUpload"
              hide-details
            ></v-file-input>
          </v-container>
        </v-card-text>
        <v-card-actions class="pr-6 pb-5">
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="uploadDialog = false">
            Cancel
          </v-btn>
          <v-btn color="primary" @click="uploadFiles" :loading="uploading">
            Upload
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5">
          Delete this file?
        </v-card-title>
        <v-card-text
          >You are about to delete <strong>{{ selectedName }}.</strong> This
          action cannot be reversed.</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="deleteDialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="error"
            :loading="isDeleting"
            text
            @click.native="deleteFile"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "Files",
  data() {
    return {
      search: "",
      files: [],
      dialog: false,
      users: [],
      selected: [],
      uploadDialog: false,
      uploadData: null,
      uploading: false,
      fileName: "",
      loading: false,
      currentUser: {},
      userData: {},
      deleteDialog: false,
      deletingFile: "",
      isDeleting: false,
      mediaID: "",
      selectedName: "",
      sharingFile: false,
      fileToShare: {
        name: "",
        id: ""
      }
    };
  },
  methods: {
    async getFiles() {
      this.loading = true;
      const AuthToken = localStorage.getItem("AuthToken");
      axios.defaults.headers.common.Authorization = AuthToken;
      let id = this.$router.currentRoute.params.id;
      try {
        const folderUrl = `${process.env.VUE_APP_BASE_URL}/folders/${id}`;
        const folderResponse = await axios.get(folderUrl);
        console.log(folderResponse);
        this.files = folderResponse.data;
      } catch (error) {
        console.log(error);
        this.$toast.error("Something went wrong getting folders");
      } finally {
        this.loading = false;
      }
    },
    async getUsers() {
      const AuthToken = localStorage.getItem("AuthToken");
      axios.defaults.headers.common.Authorization = AuthToken;
      try {
        const userUrl = `${process.env.VUE_APP_BASE_URL}/users`;
        const userResponse = await axios.get(userUrl);
        this.users = userResponse.data;
        console.log(userResponse);
      } catch (error) {
        this.$toast.error("Something went wrong getting users");
      }
    },
    async getCurrentUser() {
      const AuthToken = localStorage.getItem("AuthToken");
      axios.defaults.headers.common.Authorization = AuthToken;
      try {
        const userUrl = `${process.env.VUE_APP_BASE_URL}/users/me`;
        const userResponse = await axios.get(userUrl);
        // const userDataUrl = `${process.env.VUE_APP_BASE_URL}/users/${userResponse.data.id}`;
        // const userResponseData = await axios.get(userDataUrl);
        // this.userData = userResponseData.data;
        this.currentUser = userResponse.data;
        console.log(userResponse);
      } catch (error) {
        this.$toast.error("Something went wrong getting user");
      }
    },
    initialiseUpload(e) {
      console.log(e);
      const fileData = new FormData();
      fileData.append("files", e);
      this.uploadData = fileData;
    },
    async uploadFiles() {
      this.uploading = true;
      try {
        const fileResponse = await axios.post(
          `${process.env.VUE_APP_BASE_URL}/upload`,
          this.uploadData
        );
        await axios.post(`${process.env.VUE_APP_BASE_URL}/files`, {
          name: this.fileName,
          from: this.currentUser.id,
          folder: this.$router.currentRoute.params.id,
          media: fileResponse.data
        });
        // await axios.put(
        //   `${process.env.VUE_APP_BASE_URL}/users/${this.currentUser.id}`,
        //   {
        //     files: [...fileResponse.data, ...this.userData.files]
        //   }
        // );
        this.$toast.success("Your file has been uploaded");
        this.fileName = "";
        this.uploadData = null;
        this.uploadDialog = false;
        this.getFiles();
      } catch (e) {
        console.log(e);
        this.$toast.error("Something went wrong, could not upload file");
      } finally {
        this.uploading = false;
      }
    },
    initiateDelete(id, fileID, name) {
      this.deletingFile = id;
      this.mediaID = fileID;
      this.selectedName = name;
      this.deleteDialog = true;
    },
    async deleteFile() {
      this.isDeleting = true;
      try {
        const fileUrl = `${process.env.VUE_APP_BASE_URL}/files/${this.deletingFile}`;
        const uploadUrl = `${process.env.VUE_APP_BASE_URL}/upload/files/${this.mediaID}`;
        await axios.delete(uploadUrl);
        await axios.delete(fileUrl);
        // const newFiles = this.userData.files.filter(file => {
        //   file.id !== this.mediaID;
        // });
        // await axios.put(
        //   `${process.env.VUE_APP_BASE_URL}/users/${this.currentUser.id}`,
        //   {
        //     files: newFiles
        //   }
        // );
        this.deletingFile = "";
        this.mediaID = "";
        this.deleteDialog = false;
        this.$toast.success("File deleted successfully");
        this.getFiles();
      } catch (error) {
        console.log(error);
        this.$toast.error("Something went wrong, Could not delete this file");
      } finally {
        this.isDeleting = false;
      }
    },
    goBack() {
      this.$router.go(-1);
      console.log("back");
    },
    getLink(link) {
      let index = link.indexOf("upload");
      index = index + 6;
      return `${link.substring(0, index)}/fl_attachment${link.substring(
        index
      )}`;
    },
    initializeShare(name, id) {
      this.fileToShare = {
        name: name,
        id: id
      };
      this.dialog = true;
    },
    async shareFile() {
      if (this.$refs.fileShareForm.validate()) {
        this.sharingFile = true;
        const AuthToken = localStorage.getItem("AuthToken");
        axios.defaults.headers.common.Authorization = AuthToken;
        const file = this.files.files.find(file => {
          return file.id === this.fileToShare.id;
        });
        try {
          const userUrl = `${process.env.VUE_APP_BASE_URL}/users/${this.selected}`;
          const userData = await axios.get(userUrl);
          if (userData.data.recievedFiles.find(e => e.id === file.id)) {
            this.$toast.info(`${userData.data.username} already has this file`);
          } else {
            const update = await axios.put(userUrl, {
              recievedFiles: [file, ...userData.data.recievedFiles]
            });
            console.log(update);
            await axios.put(
              `${process.env.VUE_APP_BASE_URL}/users/${this.currentUser.id}`,
              {
                sharedNumber: this.currentUser.sharedNumber + 1
              }
            );
            this.$toast.success("File Shared Successfully");
            this.selected = [];
          }
          this.dialog = false;
        } catch (error) {
          this.$toast.error("Something went wrong getting user");
        } finally {
          this.sharingFile = false;
        }
      }
    },
    onClick(url) {
      axios({
        url: url,
        method: "GET",
        responseType: "blob"
      }).then(response => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", "file.pdf");
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    }
  },
  computed: {
    usersToShare() {
      return this.users.filter(user => {
        return user.id !== this.currentUser.id;
      });
    }
  },
  mounted() {
    const AuthToken = localStorage.getItem("AuthToken");
    if (AuthToken) {
      this.getFiles();
      this.getUsers();
      this.getCurrentUser();
    } else {
      this.$router.push("/login");
    }
  }
};
</script>
